import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

const RedirectToLoginScreen = withRouter(({ location }: RouteComponentProps) =>
  <Redirect to={{ pathname: '/auth', search: `?redirect=${location.pathname}` }} />
);

export default RedirectToLoginScreen;
